import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService, EventManager } from 'ng-jhipster';
import { School } from './school.model';
import { SchoolService } from './school.service';
import { schoolPopupRoute } from './index';
import { Subscription } from 'rxjs/Rx';
import { Principal } from '../../shared/index';
import { FileUploader } from 'ng2-file-upload';
import { BackOfficeService } from '../../shared';

@Component({
    selector: 'jhi-school-detail',
    templateUrl: './school-detail.component.html'
})
export class SchoolDetailComponent implements OnInit, OnDestroy {

    school: School;
    private subscription: any;
    eventSubscriber: Subscription;
    schoolAgendaUrl: string;
    copyTooltip = 'Click to copy';

    // variables for the image uploader
    uploader: FileUploader;
    hasBaseDropZoneOver: boolean;
    hasAnotherDropZoneOver: boolean;
    public readonly URL = 'https://evening-anchorage-3159.herokuapp.com/api/';

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private schoolService: SchoolService,
        private route: ActivatedRoute,
        private eventManager: EventManager,
        private principal: Principal,
        private backofficeService: BackOfficeService
    ) {
        this.jhiLanguageService.setLocations(['school']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.loadSchool(params['id']);

            // we create the uploader
            this.uploader = this.schoolService.getNewUploader();
            this.hasBaseDropZoneOver = false;
            this.hasAnotherDropZoneOver = false;
            this.uploader.response
                         .subscribe( res => {
                            this.school.imageUrl = res;
                         });
        });
        this.eventSubscriber = this.eventManager
                                   .subscribe('schoolListModification',
                                   (response) => {
                                       this.loadSchool(this.school.id);
                                    });
    }

    loadSchool(id) {
        this.principal
        .hasAnyAuthority(['ROLE_ADMIN'])
        .then(isPlatformAdmin => {
            if (isPlatformAdmin) {
                this.schoolService.find(id).subscribe(school => {
                    this.school = school;
                    this.schoolAgendaUrl = this.schoolService.getAgendaUrl(this.school);
                });
            } else {
                this.schoolService.findCurrent().subscribe(school => {
                    this.school = school;
                    this.schoolAgendaUrl = this.schoolService.getAgendaUrl(this.school);
                });
            }
        });
    }

    private startAccountOnboardingSession() {
        if (!this.school) {
            console.log('Error creating the account in backoffice: There is no tenant');
            return;
        }

        this.backofficeService
            .createOrResumeCreateBackofficeAccount(this.school)
            .subscribe( (res: string) => {
                this.onAccountOnbardingStarted(res);
            } , (error: Response) => console.log('Error onboarding the account: Unexpected error from the server'));
    }

    private isOnlinePaymentsEnabled() {
        return this.backofficeService.isOnlinePaymentsEnabled(this.school);
    }

    private onAccountOnbardingStarted(chechoutUrl: string) {
        // we open the onboarding page in same browser so the user can pay
         window.location.href = chechoutUrl;
    }

    getStyle(schoolField: string) {
        return  { 'background-color': this.schoolService.getColor(schoolField)};
    }

    copyToClipboard(text: string): void {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed'; // Avoid scrolling to bottom
        textarea.style.opacity = '0';

        document.body.appendChild(textarea);
        textarea.select();

        try {
          const successful = document.execCommand('copy');
          this.copyTooltip = successful ? 'Copied!' : 'Copy failed';
        } catch (err) {
          this.copyTooltip = 'Copy failed';
        }

        document.body.removeChild(textarea);
    }

    resetTooltip(): void {
        this.copyTooltip = 'Click to copy';
    }

    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.eventSubscriber.unsubscribe();
    }

     // methods for the image uploader
     public fileOverBase(e: any): void {
        this.hasBaseDropZoneOver = e;
    }

    public fileOverAnother(e: any): void {
        this.hasAnotherDropZoneOver = e;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/school/school-detail.component.ts